
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers/[slug]",
      function () {
        return require("private-next-pages/employers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers/[slug]"])
      });
    }
  